import Vue from 'vue'
import VueRouter from 'vue-router'
import TokenService from '../helpers/token'
import { updateProfileInto, checkMobile } from '../helpers/utils'
import RepositoryFactory from '../repositories/RepositoryFactory'
import AuthLayout from '../layouts/AuthLayout'

// pages
import Error403 from '../pages/Error403'
import Login from '../pages/Login'

// stores
import store from '@/store';
import { PARTNER } from "../layouts/dashboard/DrawerNew";

const AuthRepository = RepositoryFactory.get('auth');
const CampaignRepository = RepositoryFactory.get('campaign');
const PromotionRepository = RepositoryFactory.get('promotion');


const { orderMenu } = require('./order')
const { managementMenu } = require('./orderManagement')
const { productsManagement } = require('./productsManagement')
const { campaignManagement } = require('./campaignManagement')
const { promotionManagement } = require('./promotionManagement')


const permission = TokenService.getPermissions();
let isDashboardRole = permission.includes("dashboard_read");
let listSchoolLevel = [];
let listType = [];
let listActionLogType = [];
let detailCampain = null;
let detailPromotion = null;

const authPages = {
  path: '/',
  component: AuthLayout,
  name: 'Authentication',
  children: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        onlyWhenLoggedOut: true,
        public: true,
      },
    },
    {
      path: '/error-403',
      name: 'Error403',
      component: Error403,
      meta: {
        layout: 'login',
        public: true,
      },
    },
  ],
}

const routes = [
  {
    path: '/',
    // redirect: isDashboardRole ? '/dashboard' : '/products',
    name: 'Home',
  },
  authPages,
  orderMenu,
  managementMenu,
  productsManagement,
  campaignManagement,
  promotionManagement,
]
Vue.use(VueRouter)

// configure router
const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior: (to) => {
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  },
  linkExactActiveClass: 'nav-item active',
})
function formatNumber(input, type) {
  return type + input.toString().padStart(5, "0");
}
async function getDetailCampaign(id) {
  detailCampain = await CampaignRepository.getDetail(id);
}
async function getDetailPromotion(id) {
  detailPromotion = await PromotionRepository.getDetail(id);
}
// eslint-disable-next-line consistent-return
router.beforeEach(async (to, from, next) => {
  const isPublic = _.get(to.meta, 'public', false);
  const onlyWhenLoggedOut = _.get(to.meta, 'onlyWhenLoggedOut', false);
  const loggedIn = !!TokenService.getToken();
  const { title, description } = to.meta;
  const defaultTitle = "VH - POS";
  console.log("to", to);
  if (to.name === 'UpdateProduct') {
    document.title = `${formatNumber(to.params.id, 'P')} - OMS Product`;
  }
  else if (to.name === 'SkuDetail' || to.name === 'SkuComboDetail') {
    document.title = `${formatNumber(to.params.sku_id,'SD')} - OMS Price Policy`;
  }
  else if (to.name === 'UpdateCampaign') {
    detailCampain = null;
    await getDetailCampaign(to.params.id);
    document.title = (detailCampain && !detailCampain.errors) ? `${detailCampain.data.id} - OMS Campaign - ${detailCampain.data.title}` : defaultTitle;
  }
  else if (to.name === 'DetailPromotion') {
    detailPromotion = null;
    await getDetailPromotion(to.params.id);
    document.title = (detailPromotion && !detailPromotion.errors) ? `${detailPromotion.data.id} - OMS Promotion - ${detailPromotion.data.code}` : defaultTitle;
  }
  else {
    document.title = title || defaultTitle;
  }
  if (!loggedIn) {
    TokenService.removeModule();
  }

  if ((to.fullPath == '/report/employee-report-' + to.params.id) && to.params.id !== PARTNER && to.path !== '/error-403') {
    return next('/error-403');
  }

  if (isPublic) next();
  if (!isPublic && !loggedIn) {
    if (to.path === '/') {
      return next('/login');
    }

    return next({
      path: '/login',
      query: { redirect: to.fullPath }, // Store the full path to redirect the user to after login
    });
  }

  // Do not allow user to visit entry page if they are logged in
  if (loggedIn && onlyWhenLoggedOut) {
    return next({name: 'Product'});
  }

  // check role of user
  if (loggedIn) {
    const profile = await AuthRepository.profile();
    updateProfileInto(_.get(profile, 'data.profile'))
    const permissions = _.get(profile, 'data.profile.role.permissions', []).map(p => `${p.model}_${p.action}`);
    store.dispatch('SET_PERMISSION', permissions);

    if (to.path === '/') {
      const hasProductRead = permissions.includes('oms-product_read');
      const hasCampaignRead = permissions.includes('oms-campaign_read');
      const hasCodeRead = permissions.includes('oms-code_read');

      if (hasProductRead) {
        return next({ name: 'Product' });
      } else if (hasCampaignRead) {
        return next({ name: 'Campaign' });
      } else if (hasCodeRead) {
        return next({ name: 'Promotion' });
      }

      return next('/error-403');
    }

    const metaRole = _.get(to.meta, 'roles', []);

    if (metaRole === 'all') {
      next();
    } else {
      const userPermissions = TokenService.getPermissions();
      const storePermissions = store.state.permissions;

      if (!_.intersection(metaRole, userPermissions).length &&
          !_.intersection(metaRole, storePermissions).length && to.path !== '/error-403') {
        return next('/error-403');
      }
    }
  }
  next();
});


export default router;
